import { getRuntimeFeatureValues } from "../../../../../utils/v3/utils/get-runtime-feature-values.js";
import { replaceCurrentRoute } from "../../../../BookAppointment/v3/pages/BookAppointment/utils.js";
var RoutingError = /* @__PURE__ */ ((RoutingError2) => {
  RoutingError2["INVALID_ROUTE"] = "INVALID_ROUTE";
  RoutingError2["SERVER_SIDE_CONFIRMATION_ATTEMPT"] = "SERVER_SIDE_CONFIRMATION_ATTEMPT";
  return RoutingError2;
})(RoutingError || {});
const routingErrorHandler = (errorMessage, selfUrl, asPath, currentRoute, queryParams, publicRuntimeConfig, profileUrl) => {
  const { myAccount } = getRuntimeFeatureValues(publicRuntimeConfig);
  switch (errorMessage) {
    case "INVALID_ROUTE":
      return {
        type: "redirect",
        url: replaceCurrentRoute(selfUrl, asPath, currentRoute, "", queryParams)
      };
    case "SERVER_SIDE_CONFIRMATION_ATTEMPT":
      const redirectUrl = myAccount && profileUrl ? `${selfUrl}${profileUrl}` : `${selfUrl}/`;
      return {
        type: "redirect",
        url: redirectUrl
      };
    default:
      return {
        type: "not-found"
      };
  }
};
export {
  RoutingError,
  routingErrorHandler
};
//# sourceMappingURL=errors.js.map
